import actions from './module-transfer-inv-actions';
import getters from './module-transfer-inv-getters';
import mutations from './module-transfer-inv-mutation';
import state from './module-transfer-inv-state.js';

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
